import React, { Component } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import styled from "styled-components";

const ModalBody = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

class BasicModal extends Component {
  state = {};
  render() {
    const { show, onHide, title, children, footerClose } = this.props;
    return (
      <Modal show={show} onHide={onHide} style={{ maxWidth: "100%" }}>
        <Modal.Header closeButton>{title}</Modal.Header>
        <ModalBody>{children}</ModalBody>
        { footerClose && (
        <Modal.Footer>
          <Button variant={"outline-secondary"} onClick={onHide}>
            Close
          </Button>
        </Modal.Footer>)
        }
      </Modal>
    );
  }
}

export default BasicModal;
